//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    track: {
      type: Object,
      required: true
    }
  },
  methods: {
    artistNames(track) {
      var justNames = track.artists.map(x => x.name);
      return justNames.join(", ");
    }
  }
};
